"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const styles_1 = require("@mui/material/styles");
const styles_2 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_2.default);
const PayeeSpan = (props) => {
    const { initialValue, onBlur, className, variant = 'body1', style = {}, onChange } = props, otherProps = __rest(props, ["initialValue", "onBlur", "className", "variant", "style", "onChange"]);
    const { classes, cx } = useStyles();
    const theme = (0, styles_1.useTheme)();
    const [payee, setPayee] = (0, react_1.useState)(initialValue);
    const [spanRef] = (0, react_1.useState)(react_1.default.createRef());
    let update = true; // controls how to handle the blur (don't update on escape)
    const handleChange = () => {
        if (onChange && spanRef && spanRef.current) {
            onChange(spanRef.current.innerText);
        }
    };
    const handleKeyDown = (e) => {
        switch (e.keyCode) {
            case 8: // backspace
                break;
            case 13: // enter
                if (spanRef === null || spanRef === void 0 ? void 0 : spanRef.current) {
                    spanRef.current.blur();
                }
                break;
            case 27: // escape
                update = false;
                if (spanRef === null || spanRef === void 0 ? void 0 : spanRef.current) {
                    spanRef.current.blur();
                }
                break;
            default:
                break;
        }
    };
    const handlePaste = (e) => {
        e.stopPropagation();
        e.preventDefault();
        // @ts-expect-error TS(2551) - FIXME: Property 'clipboardData' does not exist on type 'Window & typeof globalThis'
        const clipboardData = e.clipboardData || window.clipboardData;
        const text = clipboardData && clipboardData.getData('Text'); // only keep textData
        window.document.execCommand('insertText', false, text);
    };
    const handleBlur = () => {
        if (!spanRef.current) {
            return;
        }
        spanRef.current.scrollLeft = 0;
        if (update) {
            setPayee(spanRef.current.innerText);
            if (onBlur) {
                onBlur(spanRef.current.innerText);
            }
        }
        else {
            spanRef.current.textContent = payee;
        }
    };
    (0, react_1.useEffect)(() => {
        setPayee(initialValue);
        if (spanRef === null || spanRef === void 0 ? void 0 : spanRef.current) {
            spanRef.current.textContent = initialValue;
        }
    }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, react_1.useEffect)(() => {
        const node = spanRef && spanRef.current;
        if (node && onChange) {
            node.addEventListener('DOMSubtreeModified', handleChange);
        }
        return () => {
            if (node) {
                node.removeEventListener('DOMSubtreeModified', handleChange);
            }
        };
    }, [spanRef, onChange]); // eslint-disable-line react-hooks/exhaustive-deps
    return (<span id="payeeSpan" role="textbox" tabIndex={0} ref={spanRef} contentEditable onKeyDown={handleKeyDown} onBlur={handleBlur} onPaste={handlePaste} className={cx(classes.root, className)} style={Object.assign(Object.assign({}, theme.typography[variant]), style)} {...otherProps}/>);
};
exports.default = PayeeSpan;
